<script setup lang="ts">
  import type { Component } from 'vue';

  interface Props {
    icon: Component;
    title: string;
    iconClass?: string;
  }

  withDefaults(defineProps<Props>(), {
    iconClass: 'size-5',
  });
</script>

<template>
  <div class="flex gap-2 items-center h-[42px] py-2 border-b border-gray-03">
    <div class="flex items-center justify-center size-6 rounded-[4px] bg-gray-03 overflow-hidden">
      <component :is="icon" class="text-white-01" :class="iconClass" :stroke-width="2" />
    </div>
    <span class="text-sm font-normal text-gray-07">
      {{ title }}
    </span>
  </div>
</template>
